import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackChargingCostCustomizeClickEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

interface UseLegacyTrackChargingCostCustomizeClickVariables {
  vehicle: ElasticVehicle;
  information: {
    label: string;
    context: 'inline';
    disance: string;
    chargingCost?: number;
  };
}

export const createLegacyTrackChargingCostCustomizeClick = (
  market: Market,
  variables: UseLegacyTrackChargingCostCustomizeClickVariables,
): LegacyTrackChargingCostCustomizeClickEventData => {
  const eventData: LegacyTrackChargingCostCustomizeClickEventData = {
    eventType: 'chargingCostCustomizeClick',
    item: mapElasticVehicleToLegacyItem(market, variables.vehicle),
    pageType: 'product page',
    information: variables.information,
  };

  return eventData;
};

export const useLegacyTrackChargingCostCustomizeClick = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyChargingCostCustomizeClick = useCallback(
    (variables: UseLegacyTrackChargingCostCustomizeClickVariables) => {
      track({
        event: 'chargingCostCustomizeClick',
        data: createLegacyTrackChargingCostCustomizeClick(market, variables),
      });
    },
    [track],
  );

  return {
    trackLegacyChargingCostCustomizeClick,
  };
};
